/**
 * 条件分岐ノードから、条件を表示する帯に出す文言を組み立てる。
 * 既存の通常エディタ(MultipleChoiceLogic / NumberConditionLogic)の文言に揃える。
 */

import {
  NumberLogicTypeEnum,
  TemplateNodeSchema,
} from '@ulysses-inc/harami_api_client'

/**
 * 条件分岐ノードの条件文言を返す。
 * - 選択肢系: 「<選択肢名(複数なら , 区切り)>」を選択した場合
 * - 数値系  : 「正常値 / 違反値」を入力した場合
 */
export const getLogicConditionLabel = (
  logicNode: TemplateNodeSchema,
): string => {
  const logic = logicNode.logic
  if (!logic) {
    throw new Error('条件分岐ノードに logic 設定がありません')
  }

  const choices = logic.responseMultipleChoices ?? []
  if (choices.length > 0) {
    const names = choices
      .map(choice => choice.response ?? '')
      .filter(name => name !== '')
      .join(', ')
    return `「${names}」を選択した場合`
  }

  const numberConditions = logic.numberConditions ?? []
  const numberCondition = numberConditions[0]
  if (numberCondition) {
    const label =
      numberCondition.logicType === NumberLogicTypeEnum.NORMAL
        ? '正常値'
        : '違反値'
    return `「${label}」を入力した場合`
  }

  throw new Error('条件分岐ノードに条件(選択肢/数値)が設定されていません')
}
